<template>
  <button class="modal-video" @click.prevent="open">
    <slot></slot>
    <div
      id="modal-video-backdrop"
      class="modal-video__modal"
      @click.exact="closeFromBackdrop"
      :title="$i18n.t('modal_video_close')"
      v-if="isVisible"
    >
      <div class="modal-video__inner">
        <div class="modal-video__inner-header" @click.prevent>
          <h4 class="modal-video__inner-header-headline">
            {{ $i18n.t(title) }}
          </h4>
          <button
            class="modal-video__inner-header-close"
            @click.prevent="close"
          >
            <MultiImage
              class="modal-video__inner-header-close-image"
              name="img_close"
            />
          </button>
        </div>
        <Video
          class="modal-video__inner-video"
          :vimeoId="vimeoId"
          :autoplay="true"
        />
      </div>
    </div>
  </button>
</template>

<script>
import Video from "@/components/Video";
import MultiImage from "@/components/MultiImage";
export default {
  name: "ModalVideo",
  props: {
    title: String,
    vimeoId: String,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  components: {
    Video,
    MultiImage,
  },
  methods: {
    open() {
      this.isVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeFromBackdrop(e) {
      if (e.target.id === "modal-video-backdrop") {
        this.close();
      }
    },
    close() {
      setTimeout(() => {
        this.isVisible = false;
        document.body.style.overflow = "visible";
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss";
.modal-video {
  &__modal {
    @include modal();
    @include flex-v(center, center);
  }

  &__inner {
    @include flex-v(center, stretch);
    width: 90%;
    height: 90%;
    margin: 5%;
    cursor: default;
    &-header {
      @include flex-h(center, center);
      margin-bottom: 15px;
      &-headline {
        flex: 1;
        color: white;
        font-family: $font_nettoBold;
        @include text(40px, 48px, 0.4px);
        text-align: left;
      }
      &-close {
        &-image {
          width: 25px;
          height: 25px;
        }
      }
    }
  }
}
</style>
